import { useState, useRef, useEffect } from 'react';
import { Video } from '@/lib/mock-data';

export const useVideoNavigation = (videos: Video[]) => {
  const [currentVideo, setCurrentVideo] = useState(0);
  const feedRef = useRef<HTMLDivElement>(null);

  const handleScroll = (e: WheelEvent) => {
    e.preventDefault();
    if (e.deltaY > 0) {
      setCurrentVideo(prev => prev === videos.length - 1 ? 0 : prev + 1);
    } else if (e.deltaY < 0) {
      setCurrentVideo(prev => prev === 0 ? videos.length - 1 : prev - 1);
    }
  };

  const handleTouchStart = (e: TouchEvent) => {
    const touch = e.touches[0];
    const startY = touch.clientY;

    const handleTouchMove = (e: TouchEvent) => {
      const touch = e.touches[0];
      const deltaY = touch.clientY - startY;

      if (Math.abs(deltaY) > 50) {
        if (deltaY < 0) {
          setCurrentVideo(prev => prev === videos.length - 1 ? 0 : prev + 1);
        } else if (deltaY > 0) {
          setCurrentVideo(prev => prev === 0 ? videos.length - 1 : prev - 1);
        }
        document.removeEventListener('touchmove', handleTouchMove);
      }
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', () => {
      document.removeEventListener('touchmove', handleTouchMove);
    }, { once: true });
  };

  useEffect(() => {
    const currentFeedRef = feedRef.current;
    if (currentFeedRef) {
      currentFeedRef.addEventListener('wheel', handleScroll, { passive: false });
      currentFeedRef.addEventListener('touchstart', handleTouchStart, { passive: false });
    }

    return () => {
      if (currentFeedRef) {
        currentFeedRef.removeEventListener('wheel', handleScroll);
        currentFeedRef.removeEventListener('touchstart', handleTouchStart);
      }
    };
  }, [videos.length]);

  return { currentVideo, feedRef };
};